// src/app/_helper/role.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
  ): boolean | UrlTree {
    // Gets the required roles defined in the route data
    const requiredRoles = route.data['roles'] as string[];
    
    // If the route doesn't have any roles specified, access is allowed
    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    // Checks if the user has the super_admin status, which gives access to everything
    if (this.tokenService.isAdmin()) {
      return true;
    }

    // Checks if the user has at least one of the required roles
    const userHasRequiredRole = requiredRoles.some(role => this.tokenService.hasRole(role));
    
    if (userHasRequiredRole) {
      return true;
    }

    // If the user doesn't have the required permissions, he is redirected to the home page or an error page
    return this.router.createUrlTree(['/']);
  }
}